


///修改前
// const App = () => import ('../App.vue');

// const main_content = r => require.ensure([], () => r(require('../page/main_content/main.vue')), 'main_content');
// export default {
//     // path: '/',
//     // redirect: '/index',
//     // component: main_content,
//     path: '/',
//     redirect: '/index',
//     component: App,
//     children: [
//       {
//         path: '/index',
//         name: 'index',
//         component: main_content
//       }
//     ]
//   }

import main_content from '../page/main_content/main.vue'


export default {
  path: '/',
  redirect: '/index',
  component: main_content,
      children: [
      {
        path: '/index',
        name: 'index',
        component: main_content
      }
    ]
}



// WEBPACK FOOTER //
// ./src/router/main_content.js